import { render, staticRenderFns } from "./ListEstablishmentPage.vue?vue&type=template&id=3735c24c"
import script from "./ListEstablishmentPage.vue?vue&type=script&lang=js"
export * from "./ListEstablishmentPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports